import { css } from "@emotion/react";

import {
  ACTIONS_TOOLBAR_HEIGHT,
  SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT,
} from "@/view/ActionsToolbar/ActionsToolbar.style";

export const globalStyleOverrideCss = (isSmallScreen = true) =>
  css({
    ":root": {
      "--layout-scroll-padding-top": isSmallScreen
        ? `${SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT}`
        : `${ACTIONS_TOOLBAR_HEIGHT}`,
    },
  });
